$( document ).ready(function() {
  $(".product-gallery-item > a.zoom_btn").click( function(event) {
    event.preventDefault();
    let item_index = $(this).data('index')
    var pswpElement = document.querySelectorAll('.pswp')[0];
    let images = document.querySelectorAll('#product_gallery .featured__collection-product');
    if ( images.length < 2 ) {
    	var arrows = false;
    } else {
    	var arrows = true;
    }
    
    let items = [];
    images.forEach((image, i) => {
    	let imageTag = image.querySelector('.product__image');
        let item = {
  		src: imageTag.getAttribute('data-zoom-src'),
  		w: imageTag.getAttribute('data-width'),
  		h: imageTag.getAttribute('data-height')
        }
        items.push(item);
    });
    var options = {
    	index: item_index,
    	arrowEl: arrows,
    	captionEl: false,
    	closeOnScroll: false,
    	counterEl: false,
    	history: false,
    	fullscreenEl: false,
    	preloaderEl: false,
    	shareEl: false,
    	tapToClose: false,
    	getThumbBoundsFn: function(index) {
    	  var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
    	  var thumbnail = document.querySelector('.product__image');
    	  var rect = thumbnail.getBoundingClientRect();
    	  return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
    	}
      };
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();

  });
});